module.exports = require('./lib/wraptile');
